import { BRAND_STYLES } from '../utils/Constants';
import { BRAND_STYLE } from './portletConfiguration';

export function hasBrandLabel(result) {
	return (
		BRAND_STYLE === BRAND_STYLES.LABEL &&
		result &&
		result.brand.props &&
		result.brand.props.content &&
		!result.brand.props.img &&
		!result.brand.props.content.type
	);
}

export function isBrandLabel(content, img) {
    if(content && content.type && img) {
	    return BRAND_STYLE === BRAND_STYLES.LABEL && !img && !content.type;
	}
	return false;
}

export function isBrandLabelCmpnt(brand) {
	if (brand && brand.props && brand.props.content && brand.props.img) {
		return isBrandLabel(brand.props.content, brand.props.img);
	}
	return false;
}
